/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: branding-media-edit-view-asset-list-component.ts
 *
 * Created by kyang on 10/29/20.
 */

function BrandingMediaEditViewAssetListController(
    this: JS5Object,
    _: JS5Object,
) {

    //===================//
    // Template Response //
    //===================//

    this.getExtraAssetPropertiesError = (index: number) => {
        return this.duplicateAssetErrors[index];
    };

    this.assetContainsAcceptProfile = () => {
        return this.assetType !== 'cc';
    };

    const updateTotalProgress = () => {
        this.ingestPercent = Math.round(_.chain(this.assetList)
            .map('_progress')
            .filter((asset: JS5Object) => !_.isNil(asset))
            .mean()
            .value() * 100);
        if (isNaN(this.ingestPercent)) {
            delete this.ingestPercent;
        }
    }

    this.onIngestProgress = (asset: JS5Object, progress: number) => {
        asset._progress = progress;
        updateTotalProgress();
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    const hasDuplicateIds = (objectArray: JS5Object[], otherArray: JS5Object[]) => {
        if (!objectArray) {
            objectArray = [];
        }
        if (!otherArray) {
            otherArray = [];
        }
        return (
            objectArray.length === otherArray.length
            && _.differenceBy(objectArray, otherArray, 'id').length === 0
        );
    };

    this.updateValidity = () => {
        let hasDuplicate = false;
        this.duplicateAssetErrors = {};
        _.forEach(this.assetList, (asset: JS5Object, index: number) => {
            let isDuplicate = _.some(this.assetList, (other: JS5Object) => (
                asset !== other
                && (!this.promptAcceptProfile || _.get(asset, 'acceptProfile.id') === _.get(other, 'acceptProfile.id'))
                && (!this.availableLanguages || _.get(asset, 'language.id') === _.get(other, 'language.id'))
                && (!this.availableRatingSystems
                    || ((_.get(asset, 'rating.ratingCode.id') === _.get(other, 'rating.ratingCode.id'))
                    && _.isEqual(
                        _.map(_.get(asset, 'rating.ratingAdvisoryCodes'), (rac: JS5Object) => rac.id).sort(),
                        _.map(_.get(other, 'rating.ratingAdvisoryCodes'), (rac: JS5Object) => rac.id).sort())))
                && (!this.availableRoles || _.get(asset, 'role.id') === _.get(other, 'role.id'))
                && (!this.availableTerritories || hasDuplicateIds(asset.territories, other.territories))
            ));
            if (isDuplicate) {
                this.duplicateAssetErrors[index] = 'Assets must have different properties';
                hasDuplicate = true;
            }
        });

        if (this.editorForm) {
            this.editorForm.$setValidity('duplicateProperties', !hasDuplicate);
        }
    };

    this.onRatingSystemChanged = (asset: JS5Object) => {
        asset.rating.ratingCode = null;
        asset.rating.ratingAdvisoryCodes = [];
        this.updateValidity();
    }

    const updatePrevState = () => {
        this.prevState = {
            assetList: this.assetList,
            'assetList.length': _.get(this, 'assetList.length'),
            availableAcceptProfiles: this.availableAcceptProfiles,
            availableLanguages: this.availableLanguages,
            availableRatingSystems: this.availableRatingSystems,
            availableRoles: this.availableRoles,
            availableTerritories: this.availableTerritories,
            selectedRatingSystems: this.selectedRatingSystems,
        };
    };

    this.$doCheck = () => {
        if (_.some(this.prevState, (prevValue: any, property: string) => {
            return _.get(this, property) !== prevValue;
        })) {
            if (this.assetList !== this.prevState.assetList || this.assetList.length !== this.prevState['assetList.length']) {
                updateTotalProgress();
            }
            this.updateValidity();
            updatePrevState();
        }
    };

    this.$onInit = () => {
        this.updateValidity();
        updatePrevState();
    };
}

angular
    .module('prism-ui.components.branding')
    .component('brandingMediaEditViewAssetList', {
        templateUrl: 'components/branding/editView/components/media/editView/components/assetList/branding-media-edit-view-asset-list-template.html',
        controller: BrandingMediaEditViewAssetListController,
        bindings: {
            sectionName: '@',
            containerType: '@',
            assetType: '@',
            rootAsset: '<',
            assetList: '<',

            availableAcceptProfiles: '<?',
            availableLanguages: '<',
            availableRoles: '<',
            availableRatingSystems: '<',
            availableTerritories: '<',
            selectedRatingSystems: '<',
            promptAcceptProfile: '<',
            addAsset: '<',
            removeAsset: '<',
        }
    });
